import {computed, ref} from 'vue';
import {send} from '@api/cart';

export const cartRepository = products => {
    const cartItems = ref([]);
    const promoIsOn = ref(false);
    const promoCode = ref(null);

    const cartItem = pId => cartItems.value.find(p => p.productId === pId);
    const cartItemCount = pId => (cartItem(pId) ? cartItem(pId).count : 0);

    const setProductCount = (productId, count) => {
        if (cartItem(productId)) {
            cartItem(productId).count = count;
        } else {
            cartItems.value.push({
                count: Number(count),
                productId
            });
        }

        cartItems.value = cartItems.value.filter(item => item.count);
    };

    const addProduct = (pId, count) => {
        const newCount = cartItemCount(pId) + count;
        setProductCount(pId, newCount < 0 ? 0 : newCount);
    };

    const inputProductCount = (pId, count) => {
        setProductCount(pId, count);
    };

    const productsInCart = computed(() => cartItems.value.filter(v => v.count).map(item => {
        const product = products.value.find(p => p.id === item.productId);

        return {
            ...item,
            product,
            price: (promoIsOn.value ? 400 : product.price) * item.count
        };
    }));

    const totalCountInCart = computed(
        () => cartItems.value.reduce((r, item) => r + item.count, 0)
    );

    const totalPriceInCart = computed(
        () => productsInCart.value.reduce((r, item) => r + item.price, 0)
    );

    const productInCartCount = pId => cartItemCount(pId);

    const sendCart = (data, callback) => send(data).then(response => {
        callback(response);
    });

    return {
        addProduct,
        inputProductCount,
        productsInCart,
        productInCartCount,
        totalCountInCart,
        totalPriceInCart,
        sendCart,
        cartItems,
        promoIsOn,
        promoCode
    };
};
